import { chakra } from "@chakra-ui/react"
import { textRecipe } from "../../themes"

export const Text = chakra("p", textRecipe)